export default __webpack_public_path__ + "static/media/november-min.0f2f94b1.jpg";